var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{attrs:{"type":"warning"},on:{"click":function($event){return _vm.act('do')}}},[_vm._v("开始维护")]),_c('p'),_c('el-button',{attrs:{"type":"success"},on:{"click":function($event){return _vm.act('cancel')}}},[_vm._v("解除维护")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }